import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CreditOverviewCardComponent } from '@brightnav/credit-overview';
import { FinancialSnapshotCardComponent } from '@brightnav/financial-snapshot';
import { FeatureFlagKey, FeatureFlagsService } from '@brighthub/feature-flags';
import { map } from 'rxjs';

function isFlagOn(value: unknown): boolean {
  return value !== false && value !== null && value !== undefined;
}

/**
 * Finances tab host — vertical stack of collapsible Finances sections.
 * Add future `bn-collapsible-section` features here without touching FA layout.
 */
@Component({
  selector: 'bn-finances-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CreditOverviewCardComponent, FinancialSnapshotCardComponent],
  template: `
    <div class="bn-finances-tab flex flex-col gap-4">
      @if (financialSnapshotEnabled()) {
        <bn-financial-snapshot-card />
      }
      @if (creditOverviewEnabled()) {
        <bn-credit-overview-card />
      }
    </div>
  `,
})
export class FinancesTabComponent {
  private readonly _featureFlags = inject(FeatureFlagsService);

  readonly financialSnapshotEnabled = toSignal(
    this._featureFlags
      .getValueChanges$(FeatureFlagKey.ENABLEFINANCIALSNAPSHOT, false)
      .pipe(map(isFlagOn)),
    { initialValue: false },
  );

  readonly creditOverviewEnabled = toSignal(
    this._featureFlags
      .getValueChanges$(FeatureFlagKey.ENABLECREDITOVERVIEW, false)
      .pipe(map(isFlagOn)),
    { initialValue: false },
  );
}
